/* Tuff Vibe theme JS — vanilla, no dependencies. */
(function () {
  'use strict';

  var doc = document, body = doc.body;

  /* ---------- Header: solid after scroll ---------- */
  var header = doc.querySelector('[data-header]');
  function onScroll() {
    if (!header) return;
    if (window.scrollY > 24) header.classList.add('is-scrolled');
    else header.classList.remove('is-scrolled');
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  /* ---------- Mobile nav ---------- */
  /* C-020 (2026-08-29): real scroll lock. The old lock relied on a compiled CSS rule whose selector
     was missing its class dot, so the page scrolled freely behind the open drawer. The body is now
     position:fixed at the recorded offset while open (works on iOS Safari, where overflow:hidden on
     body alone does not lock), and the scroll position is restored instantly on close. */
  var nav = doc.querySelector('[data-mobile-nav]');
  var toggle = doc.querySelector('[data-menu-toggle]');
  var navScrollY = 0;
  function openNav() {
    if (!nav) return;
    nav.hidden = false;
    navScrollY = window.scrollY || 0;
    body.classList.add('tuff-nav-open');
    body.style.top = -navScrollY + 'px';
    if (toggle) toggle.setAttribute('aria-expanded', 'true');
    var first = nav.querySelector('a, button');
    if (first) first.focus();
  }
  function closeNav() {
    if (!nav) return;
    nav.hidden = true;
    body.classList.remove('tuff-nav-open');
    body.style.top = '';
    window.scrollTo({ top: navScrollY, left: 0, behavior: 'instant' });
    if (toggle) { toggle.setAttribute('aria-expanded', 'false'); toggle.focus(); }
  }
  if (toggle) toggle.addEventListener('click', openNav);
  doc.querySelectorAll('[data-menu-close]').forEach(function (b) { b.addEventListener('click', closeNav); });
  doc.addEventListener('keydown', function (e) { if (e.key === 'Escape' && nav && !nav.hidden) closeNav(); });
  if (nav) nav.querySelectorAll('a').forEach(function (a) { a.addEventListener('click', closeNav); });

  /* ---------- Reveal on scroll ---------- */
  var reveals = doc.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window && reveals.length) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('revealed'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.05 });
    reveals.forEach(function (el) { io.observe(el); });
  } else {
    reveals.forEach(function (el) { el.classList.add('revealed'); });
  }
  // Safety: anything still hidden after 2.5s gets revealed (e.g. theme editor)
  setTimeout(function () { reveals.forEach(function (el) { el.classList.add('revealed'); }); }, 2500);

  /* ---------- Gallery filters ---------- */
  /* C-062: filtering is page-wide across ALL [data-gallery] instances, not per-instance.
     The gallery page chains two gallery-filtered sections (Shopify caps a section at 50
     blocks); the first section's filter bar must drive the pieces in both. Buttons and
     items are collected across every instance so any filter bar controls every piece. */
  (function () {
    var buttons = doc.querySelectorAll('[data-gallery] [data-filter]');
    var items = doc.querySelectorAll('[data-gallery] [data-tags]');
    if (!buttons.length) return;
    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var f = btn.getAttribute('data-filter');
        buttons.forEach(function (b) { b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
        items.forEach(function (it) {
          var tags = (it.getAttribute('data-tags') || '').toLowerCase().split('|');
          var show = f === 'all' || tags.indexOf(f.toLowerCase()) !== -1;
          it.classList.toggle('is-hidden', !show);
        });
      });
    });
  })();

  /* ---------- Quantity steppers ---------- */
  doc.querySelectorAll('.tuff-qty').forEach(function (q) {
    var input = q.querySelector('input');
    q.querySelectorAll('button').forEach(function (b) {
      b.addEventListener('click', function () {
        var v = parseInt(input.value || '1', 10);
        var min = parseInt(input.min || '1', 10);
        v = b.dataset.dir === 'up' ? v + 1 : Math.max(min, v - 1);
        input.value = v;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });

  /* ---------- Product variant picker ---------- */
  doc.querySelectorAll('[data-product-form]').forEach(function (form) {
    var variantsEl = form.querySelector('[data-variants]');
    if (!variantsEl) return;
    var variants = JSON.parse(variantsEl.textContent);
    var idInput = form.querySelector('input[name="id"]');
    var priceEl = form.querySelector('[data-price]');
    var btn = form.querySelector('[data-add]');
    var groups = form.querySelectorAll('[data-option-index]');
    function money(cents) {
      var fmt = form.getAttribute('data-money-format') || '${{amount}}';
      var amount = (cents / 100).toFixed(2);
      return fmt.replace(/\{\{\s*amount\s*\}\}/, amount).replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100));
    }
    function selected() {
      var opts = [];
      groups.forEach(function (g) {
        var active = g.querySelector('.is-active');
        opts.push(active ? active.getAttribute('data-value') : null);
      });
      return variants.filter(function (v) {
        return opts.every(function (o, i) { return o === null || v.options[i] === o; });
      })[0];
    }
    function update() {
      var v = selected();
      if (!v) { btn.disabled = true; btn.textContent = btn.getAttribute('data-unavailable'); return; }
      idInput.value = v.id;
      if (priceEl) priceEl.textContent = money(v.price);
      btn.disabled = !v.available;
      btn.textContent = v.available ? btn.getAttribute('data-add-label') : btn.getAttribute('data-soldout');
    }
    groups.forEach(function (g) {
      g.querySelectorAll('.tuff-variant-btn').forEach(function (b) {
        b.addEventListener('click', function () {
          g.querySelectorAll('.tuff-variant-btn').forEach(function (x) { x.classList.remove('is-active'); });
          b.classList.add('is-active');
          update();
        });
      });
    });
    update();
  });

  /* ---------- Cart line quantity auto-submit ---------- */
  doc.querySelectorAll('[data-cart-form] input[name^="updates"]').forEach(function (inp) {
    inp.addEventListener('change', function () { inp.form.submit(); });
  });

  /* ---------- Smooth anchor scroll offset for fixed header ---------- */
  doc.querySelectorAll('a[href^="#"]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var id = a.getAttribute('href').slice(1);
      if (!id) return;
      var t = doc.getElementById(id);
      if (!t) return;
      e.preventDefault();
      var y = t.getBoundingClientRect().top + window.scrollY - 80;
      window.scrollTo({ top: y, behavior: 'smooth' });
    });
  });
})();
